module.exports = __webpack_public_path__ + "img/FR30588.28d778a6.png";